import { render } from "./NavbarTasksBell.vue?vue&type=template&id=0c241948&scoped=true&ts=true&lang=pug"
import script from "./NavbarTasksBell.vue?vue&type=script&lang=ts"
export * from "./NavbarTasksBell.vue?vue&type=script&lang=ts"

import "./NavbarTasksBell.vue?vue&type=style&index=0&id=0c241948&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c241948"]])

export default __exports__